<template>
  <v-navigation-drawer
    v-model="isDrawerMenuOpen"
    app fixed overflow
    :temporary="mobileView"
    :permanent="!mobileView"
    :clipped="!mobileView"
    :touchless="!mobileView">

      <v-list class="pa-0">
        <template v-for="item in items">
          <v-list-tile :to="item.path" :key="item.path">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider :key="item.title"/>
        </template>
      </v-list>

      <v-list class="pa-0" v-if="externalLinks">
        <template v-for="item in externalLinks">
          <v-list-tile @click="navigateToItemURL(item.url)" :key="item.id">
            <v-list-tile-action>
              <v-icon>link</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider :key="item.name+'divider'"/>
        </template>
      </v-list>
      <v-progress-circular indeterminate v-else />

      <v-list class="pa-0">
        <template>
          <v-list-tile key="logout" @click="logOut">
            <v-list-tile-action>
              <v-icon>exit_to_app</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Sair</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider />
        </template>
      </v-list>
  </v-navigation-drawer>
</template>

<script>
import { auth, menuItems } from '@/services'
import * as api from '@/api'

/**
 * @group AppNavigation
 * Componente de controle da navegação do App.
 * Exibe menu com itens de navegação.
 */
export default {
  name: 'NavigationDrawer',

  props: {
    // Controle de vizualização do dispositivo
    mobileView: {
      type: Boolean,
      required: true
    },

    // Controla estado do Drawer
    isDrawerOpen: {
      type: Boolean,
      required: true
    }
  },

  data: () => ({
    externalLinks: []
  }),

  computed: {
    items () {
      return menuItems
    },

    isDrawerMenuOpen: {
      get () {
        return this.isDrawerOpen
      },

      set () {
        return null
      }
    }
  },

  mounted () {
    api.responsibleMenu.get().then(({ data }) => {
      this.externalLinks = this.sortItems(data)
    }).catch(error => { throw Error(error) })
  },

  methods: {
    /**
     * @vuese
     * Método para logOut do app
     */
    logOut () {
      auth.removeUserAuthData()
      this.$router.push('/login')
    },

    // @vuese Sort de itens do menu
    sortItems (items) {
      return items.sort((a, b) => a.sequence - b.sequence)
    },

    // @vusese metodo para navegar ao item de url externo do menu
    navigateToItemURL (url) {
      window.open(url, '_blank')
    }
  }
}
</script>
